/**
 * @file 反作弊代码 ck
 * @author taoxutian(taoxutian@baidu.com)
 * @author chengong03(chengong03@baidu.com)
 * @date 2019-02-21
 */

// wise ck 域代码参考：
// http://icode.baidu.com/repos/baidu/adu-fe/vuitemplate/blob/master:src/template/wise/grid_search/js/iphone/ck.js

/* eslint-disable no-unused-vars, no-loop-func */
/**
 * 设备是否ios
 */
let deviceIsIOS;
/**
 * 唯一实例存放变量
 */
let uniqueInstance;
/**
 * body
 */
let bd;
/**
 * touchStart 时间戳
 */
let touchStartTime;
/**
 * touchEnd 时间戳
 */
let touchEndTime;
/**
 * touchStartTime 和 touchEndTime 的差
 */
let pressTime;
/**
 * touchStart X 坐标 相对屏幕
     */
let touchX;
/**
 * touchStart Y 坐标相对屏幕
 */
let touchY;
/**
 * 是否开始滚动
 */
let isStartScroll;
/**
 * 最近一次滚动的Y坐标
 */
let scrollLastY;
/**
 * 开始滚动的Y坐标
 */
let scrollStartY;
/**
 * 开始滚动的时间
 */
let scrollStartTime;
/**
 * 最近一次滚动的时间
 */
let scrollLastTime;
/**
 * 滚动整体时间
 */
let scrollTotalTime;
/**
 * 滚动方向
 */
let scrollDirection;
/**
 * 滚动次数
 */
let scrollNum;
/**
 * 滚动方向改变量
 */
let scrollTotalChange;
/**
 * 有效滚动距离
 */
let validDirection;
/**
 * 滚动阈值
 * @type {Number}
 */
let scrollBoundary = 10;
/**
 * 匹配数字的正则表达式
 * @type {RegExp}
 */
let numReg = /\d+/;
/**
 * 点击时间
 */
let clickTime;
/**
 * 点击坐标X
 */
let clickX;
/**
 * 点击坐标Y
 */
let clickY;
/**
 * 点击时间和touchEnd时间差
 */
let diffclickTimeAndTouchEndTime;
/**
 * 卡片选择器
 */
let cardSelector;
/**
 * 卡片高度
 */
let cardWidth;
/**
 * 卡片宽度
 */
let cardHeight;

/**
 * 构造
 *
 * @param {string} selector 卡片选择器
 * @return {Object} 暴露接口方法
 */
function constructor(selector) {
  bd = document.body;
  touchStartTime = 0;
  touchEndTime = 0;
  pressTime = 0;
  touchX = 0;
  touchY = 0;
  scrollLastY = 0;
  scrollStartY = 0;
  scrollStartTime = 0;
  scrollLastTime = 0;
  scrollTotalTime = 0;
  scrollDirection = 'none';
  scrollNum = 0;
  scrollTotalChange = 0;
  validDirection = 'none';
  clickTime = 0;
  clickX = 0;
  clickY = 0;
  diffclickTimeAndTouchEndTime = 0;
  cardWidth = 0;
  cardHeight = 0;
  cardSelector = selector;
  addListener();
  return {
    addCkOnUrl,
    clearCount,
    addAdsCk,
    removeListener
  };
}

/**
 * 监听事件
 */
function addListener() {
  removeListener();
  bd.addEventListener('touchstart', onTouchStart, true);
  bd.addEventListener('touchend', onTouchEnd, true);
  bd.addEventListener('touchmove', onTouchMove, true);
  bd.addEventListener('click', onClickEvent, true);
  window.addEventListener('scroll', onScrollEvent, true);
  if (window.B && window.B.one) {
    window.B.one('destory', () => {
      removeListener();
    });
  }
}

/**
 * 移除事件
 */
function removeListener() {
  bd.removeEventListener('touchstart', onTouchStart, true);
  bd.removeEventListener('touchend', onTouchEnd, true);
  bd.removeEventListener('touchmove', onTouchMove, true);
  bd.removeEventListener('click', onClickEvent, true);
  window.removeEventListener('scroll', onScrollEvent, true);
}

/**
 * touchStart 事件处理
 *
 * @param  {event} event touchStart 事件处理
 */
function onTouchStart(event) {
  let touch = event && event.touches && event.touches.item(0);
  touchX = parseInt(touch.pageX, 10);
  touchY = parseInt(touch.pageY, 10);
  countScrollOnTouchStart();
  touchStartTime = getEventTime(event);
  setCardWidthAndHeight(event);
}
function onTouchEnd(event) {
  touchEndTime = getEventTime(event);
  if (touchEndTime > touchStartTime) {
    pressTime = Math.round(touchEndTime - touchStartTime);
  } else {
    pressTime = 0;
  }
  setCardWidthAndHeight(event);
}

/**
 * 通过touchMove 来模拟触发 scroll 事件
 *
 * @param  {Object} event 事件
 */
function onTouchMove(event) {
  onScrollEvent(event);
}

/**
 * 滚动事件处理
 *
 * @param  {event} event scroll 事件
 */
function onScrollEvent(event) {
  if (!isStartScroll) {
    isStartScroll = true;
    scrollStartY = window.scrollY;
  }
  let nowScrollY = window.scrollY;
  let scrollValue = Math.abs(nowScrollY - scrollLastY);
  let nowDirection = getScrollDirection(scrollLastY, nowScrollY) || scrollDirection;
  let eventTime = getEventTime(event);
  if (isValidScroll(scrollValue, nowDirection)) {
    if (eventTime > scrollLastTime) {
      scrollLastTime = eventTime;
    }
    if (validDirection === 'none') {
      validDirection = scrollDirection;
      scrollStartTime = eventTime;
    }
    if (validDirection !== scrollDirection) {
      scrollCount();
      scrollStartTime = eventTime;
      validDirection = scrollDirection;
    }
  }
  scrollLastY = nowScrollY;
}

/**
 * click 事件处理
 *
 * @param  {event} event click
 */
function onClickEvent(event) {
  clickTime = getEventTime(event);
  clickX = event.pageX;
  clickY = event.pageY;
  setCardWidthAndHeight(event);
}

/**
 * 设置卡片宽度和高度
 *
 * @param {Event} event 事件
 */
function setCardWidthAndHeight(event) {
  let cardDom = findParentBySelector(event.target, cardSelector);
  if (cardDom) {
    cardWidth = cardDom.offsetWidth;
    cardHeight = cardDom.offsetHeight;
  }
}

/**
 * 在滚动开始时，计数
 */
function countScrollOnTouchStart() {
  if (isStartScroll && validDirection !== 'none') {
    scrollCount();
    scrollTotalChange = 0;
    isStartScroll = false;
    scrollDirection = 'none';
  }
}

/**
 * 是否是有小滚动
 *
 * @param  {number}  scrollValue  滚动距离
 * @param  {string}  nowDirection 滚动方向
 * @return {boolean}              是否是有效滚动
 */
function isValidScroll(scrollValue, nowDirection) {
  if (scrollDirection === 'none') {
    scrollDirection = nowDirection;
  }
  if (nowDirection !== scrollDirection) {
    scrollDirection = nowDirection;
    scrollTotalChange = 0;
  } else {
    scrollTotalChange += scrollValue;
  }
  return scrollTotalChange > scrollBoundary;
}

/**
 * 获取滚动方向
 *
 * @param  {number} startY 开始滚动Y坐标
 * @param  {number} nowY   当前坐标
 * @return {string}        滚动方向 up 上  down 下
 */
function getScrollDirection(startY, nowY) {
  if (nowY > startY) {
    return 'up';
  }
  if (nowY < startY) {
    return 'down';
  }
  return false;
}

/**
 * 滚动次数计数
 */
function scrollCount() {
  scrollNum++;
  scrollTotalTime += Math.round(scrollLastTime - scrollStartTime);
  validDirection = 'none';
}

/**
 * 获取事件时间
 *
 * @param  {event} event 触发事件
 * @return {number}       时间戳
 */
function getEventTime(event) {
  if (event.timeStamp !== 0) {
    return event.timeStamp;
  }
  let date = new Date();
  return date.getTime();
}

/**
 * a数组里是否有包含和b相等的元素
 *
 * @param  {Array} a 数组a
 * @param  {Object} b 查找b
 * @return {boolen}   是否包含
 */
function collectionHas(a, b) {
  for (let i = 0, len = a.length; i < len; i++) {
    if (a[i] === b) {
      return true;
    }
  }
  return false;
}

/**
 * 寻找包含某选择器的父节点
 *
 * @param  {element} elm      选择父节点的元素
 * @param  {element} selector 选择器
 * @return {element}          符合选择器的父节点
 */
function findParentBySelector(elm, selector) {
  let all = document.querySelectorAll(selector);
  let cur = elm.parentNode;
  while (cur && !collectionHas(all, cur)) {
    cur = cur.parentNode;
  }
  return cur;
}

/**
 * 添加ck到url后面
 *
 * @param {string}  url        被添加ck的url
 * @param {number}  imTimeSign 检索时间戳
 * @param {number} isInit     是否是初始化
 * @return {string} 添加好ck的url
 */
function addCkOnUrl(url, imTimeSign, isInit) {
  let ckValue = getCkValue(url, imTimeSign, isInit);
  if (ckValue === false) {
    return url;
  }
  if (url.indexOf('&ck=') === -1) {
    url += '&ck=' + ckValue;
  } else {
    url = url.replace(/&ck=[\w.]*/, '&ck=' + ckValue);
  }
  return url;
}

/**
 * 清空滚动计数
 */
function clearCount() {
  scrollNum = 0;
  scrollTotalTime = 0;
}

/**
 * 给广告区域添加ck
 *
 * @param {Object} doms         dom数组
 * @param {number} imTimeSign   检索时间戳
 */
function addAdsCk(doms, imTimeSign) {
  let aDom;
  for (let i = doms.length - 1; i >= 0; i--) {
    aDom = doms[i] && doms[i].querySelectorAll && doms[i].querySelectorAll('a') || [];
    for (let j = aDom.length - 1; j >= 0; j--) {
      let aDomCurrent = aDom[j];
      if (aDomCurrent.tagName === 'A' && aDomCurrent.href !== '' && aDomCurrent.href.indexOf('baidu') !== -1) {
        // 添加初始化ck
        addCkToADom(aDomCurrent, imTimeSign, 1);
        aDomCurrent.addEventListener('touchend', function () {
          clickTime = 0;
          clickX = 0;
          clickY = 0;
          addCkToADom(this, imTimeSign);
        }, true);
        aDomCurrent.addEventListener('click', function () {
          addCkToADom(this, imTimeSign);
          clearCount();
        }, true);
      }
    }
  }
}

/**
 * 给 A标签添加 ck
 *
 * @param {Object}  aDom       a标签的dom
 * @param {number}  imTimeSign 检索时间戳
 * @param {boolean} isInit    是否是初始化
 */
function addCkToADom(aDom, imTimeSign, isInit) {
  aDom.href = addCkOnUrl(aDom.href, imTimeSign, isInit);
}

/**
 * 获取ck值
 *
 * @param  {string}  url        计费url
 * @param  {number}  imTimeSign 检索时间戳
 * @param  {boolean} isInit     是否是初始化
 * @return {string}             ck值 x.x.x.x.x.x
 */
function getCkValue(url, imTimeSign, isInit) {
  if (typeof url !== 'string') {
    return false;
  }
  // 正常的广告链接应该是这样：
  // - baidu.php?url=xxx
  // B2B 的跳转链接是这样
  // - /b2bsearch/jump?url=xxx
  // 理论上非广告不需要加 ck 域，这次为了方便一些反作弊统计，也加上
  if (url.indexOf('?url=') === -1) {
    return false;
  }
  if (isInit === 1) {
    return '0.0.0.0.0.0.0.0.0.0.0';
  }
  let checkCode = getCheckCode(url, imTimeSign, pressTime, touchX);
  if (checkCode === false) {
    return false;
  }
  diffclickTimeAndTouchEndTime = 0;
  if (clickTime > 0 && clickTime > touchEndTime) {
    diffclickTimeAndTouchEndTime = Math.round(clickTime - touchEndTime);
  }
  let ckValue = [checkCode,
  // 校验CRC
  pressTime,
  // 按下弹起时间差
  touchX,
  // touch事件点击X坐标
  touchY,
  // touch事件点击Y坐标
  cardWidth,
  // 此条广告的展现宽度
  cardHeight,
  // 此条广告的展现高度
  scrollNum,
  // 用户在屏幕内的触屏滑动次数
  scrollTotalTime,
  // 用户在屏幕内触屏滑动的总时间
  diffclickTimeAndTouchEndTime,
  // touch到click的时间差
  clickX,
  // click事件x坐标（应该几乎等于touchX）
  clickY // click事件y坐标（应该几乎等于touchY）
  ].join('.');
  return ckValue;
}

/**
 * 获取校验码
 *
 * @param  {string} href       计费url
 * @param  {number} imTimeSign 检索时间戳
 * @param  {number} pressTime  touchStart和touchEnd时间差
 * @param  {number} touchX     touchX的坐标
 * @return {number}            检验码
 */
export function getCheckCode(href, imTimeSign, pressTime, touchX) {
  // JMX 链接的处理
  // JMX 链接一般形式为：/portal/search?url={落地页url|竞价广告的url|暗投广告url}
  // - 落地页url例子：www.1688.com/xxxxx
  // - 竞价广告url：www.baidu.com/aladdin.php?{i域}.{j域}.{k域}
  // - 暗投广告url：www.baidu.com/baidu.php?{i域}.{j域}.{k域}

  let b2bUrlRegExec = /portal\/redirect\?url=([^&]+)/.exec(href);
  let b2bJumpUrl;
  if (b2bUrlRegExec) {
    b2bJumpUrl = decodeURIComponent(b2bUrlRegExec[1]);
  }

  // 兼容没有被 B2B 链接包裹起来的情况
  b2bJumpUrl = b2bJumpUrl || href;
  if (!b2bJumpUrl) {
    return false;
  }
  let adUrlRegExec = /\.php\?url=([^.]+)\./.exec(b2bJumpUrl);

  // i域
  let iDomain;
  let iDomainLen;

  // 对于竞价广告和暗投广告，我们需要取到 i 域
  if (adUrlRegExec) {
    iDomain = adUrlRegExec[1];
    iDomainLen = iDomain.length;
  }
  // 对于普通的落地页，目前没有强要求（取 url 长度即可，不足 20 取 20）
  else {
    iDomain = b2bJumpUrl;
    iDomainLen = iDomain.length < 20 ? iDomain.length : 20;
  }

  // 计算 checkcode
  let checkCode = 0;
  for (let x = 0; x < pressTime * imTimeSign % 99 + 9; ++x) {
    checkCode += iDomain.charCodeAt(touchX * x % iDomainLen);
  }
  return checkCode;
}
export default {
  getInstance(selector) {
    if (!uniqueInstance) {
      uniqueInstance = constructor(selector);
    }
    return uniqueInstance;
  }
};